<template>
  <div>
    <!-- Uitkeringsschema -->
    <div class="card">
      <div class="print">
        <img class="db-logo" src="../../../assets/db/DB-logo1.svg" />
        <h2 class="title">Indicatief uitkeringsschema - {{ offerTypeToText }}</h2>
        <p style="line-height: 150%">
          Hieronder ziet u het indicatieve uitkeringsschema waarbij is gerekend met een netto
          voorbeeldrendement van {{ rendement }}%<sup>*</sup>. Periodiek berekenen we de hoogte van
          uw nieuwe uitkering. Dat doen we in ieder geval elk jaar op basis van gerealiseerd
          resultaat. Dit houdt in dat uw uitkeringen jaarlijks kunnen stijgen of dalen<sup>*</sup>.
          Heeft u liever zekerheid over de hoogte van uw uitkering? Kies dan voor garantielijfrente.
        </p>
        <div style="overflow: auto">
          <table class="transparent-table">
            <tr>
              <th></th>
              <th>Begin</th>
              <th>Rendement<sup>*</sup></th>
              <th>Uitkering</th>
              <th>Slot</th>
            </tr>
            <tr v-for="(waarde, index) in renderVerloop.slice(0, 20)" :key="index">
              <th>{{ index + 1 }}</th>
              <td>&euro;&nbsp;{{ formatPrice(waarde.start, true) }}</td>
              <td>&euro;&nbsp;{{ formatPrice(waarde.profit, true) }}</td>
              <td>&euro;&nbsp;{{ formatPrice(waarde.uitkering, true) }}</td>
              <td>&euro;&nbsp;{{ formatPrice(waarde.end, true) }}</td>
            </tr>
          </table>
        </div>
        <p v-if="renderVerloop.length < 21" style="line-height: 150%">
          De berekende uitkering is het
          {{
            (offerType === 4 || offerType === 5)
              ? 'netto bedrag dat u ontvangt.'
              : `bruto bedrag. Doelbeleggen houdt loonheffing in op uw uitkering, u ontvang dus een
              netto bedrag.`
          }}
          De bovenstaande berekening is indicatief en er kunnen geen rechten aan worden
          ontleend.<sup>*</sup>
        </p>

      </div>
      <div class="docdate">
        {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        {{
          persoonsData.geslacht
            ? persoonsData.geslacht === 'man' ? 'de heer': 'mevrouw'
            : 'de heer/mevrouw'
        }}
        {{(persoonsData.roepnaam || persoonsData.voornaam) || '' }}
        {{ persoonsData.tussenvoegsel || '' }}
        {{ persoonsData.achternaam || '' }}
        <br />
        Indicatieve berekening {{ goalType }}
      </div>
      <div class="pagenumber" />
      <div class="break" v-if="renderVerloop.length > 20" />
    </div>

    <div class="card" v-if="renderVerloop.length > 20">
      <div class="print">
        <img class="db-logo" src="../../../assets/db/DB-logo1.svg" />

        <table class="transparent-table">
          <tr>
            <th></th>
            <th>Begin</th>
            <th>Rendement<sup>*</sup></th>
            <th>Uitkering</th>
            <th>Slot</th>
          </tr>
          <tr v-for="(waarde, index) in renderVerloop.slice(20, 40)" :key="index">
            <th>{{ 21 + index }}</th>
            <td>&euro;&nbsp;{{ formatPrice(waarde.start, true) }}</td>
            <td>&euro;&nbsp;{{ formatPrice(waarde.profit, true) }}</td>
            <td>&euro;&nbsp;{{ formatPrice(waarde.uitkering, true) }}</td>
            <td>&euro;&nbsp;{{ formatPrice(waarde.end, true) }}</td>
          </tr>
        </table>

        <p v-if="renderVerloop.length < 41" style="line-height: 150%">
          De berekende uitkering is het
          {{
            (offerType === 4 || offerType === 5)
              ? 'netto bedrag dat u ontvangt.'
              : `bruto bedrag. Doelbeleggen houdt loonheffing in op uw uitkering, u ontvang dus een
              netto bedrag.`
          }}
          De bovenstaande berekening is indicatief en er kunnen geen rechten aan worden
          ontleend.<sup>*</sup>
        </p>

      </div>
      <div class="docdate">
        {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        {{
          persoonsData.geslacht
            ? persoonsData.geslacht === 'man' ? 'de heer': 'mevrouw'
            : 'de heer/mevrouw'
        }}
        {{(persoonsData.roepnaam || persoonsData.voornaam) || '' }}
        {{ persoonsData.tussenvoegsel || '' }}
        {{ persoonsData.achternaam || '' }}
        <br />
        Indicatieve berekening {{ goalType }}
      </div>
      <div class="pagenumber" />
      <div class="break" v-if="renderVerloop.length > 40" />
    </div>

    <div class="card" v-if="renderVerloop.length > 40">
      <div class="print">
        <img class="db-logo" src="../../../assets/db/DB-logo1.svg" />

        <table class="transparent-table">
          <tr>
            <th></th>
            <th>Begin</th>
            <th>Rendement<sup>*</sup></th>
            <th>Uitkering</th>
            <th>Slot</th>
          </tr>
          <tr v-for="(waarde, index) in renderVerloop.slice(40, 60)" :key="index">
            <th>{{ 41 + index }}</th>
            <td>&euro;&nbsp;{{ formatPrice(waarde.start, true) }}</td>
            <td>&euro;&nbsp;{{ formatPrice(waarde.profit, true) }}</td>
            <td>&euro;&nbsp;{{ formatPrice(waarde.uitkering, true) }}</td>
            <td>&euro;&nbsp;{{ formatPrice(waarde.end, true) }}</td>
          </tr>
        </table>

        <p v-if="renderVerloop.length < 21" style="line-height: 150%">
          De berekende uitkering is het
          {{
            (offerType === 4 || offerType === 5)
              ? 'netto bedrag dat u ontvangt.'
              : `bruto bedrag. Doelbeleggen houdt loonheffing in op uw uitkering, u ontvang dus een
              netto bedrag.`
          }}
          De bovenstaande berekening is indicatief en er kunnen geen rechten aan worden
          ontleend.<sup>*</sup>
        </p>

      </div>
      <div class="docdate">
        {{today.getDate()}}-{{today.getMonth() + 1}}-{{today.getFullYear()}}
      </div>
      <div class="pagefooter">
        {{
          persoonsData.geslacht
            ? persoonsData.geslacht === 'man' ? 'de heer': 'mevrouw'
            : 'de heer/mevrouw'
        }}
        {{(persoonsData.roepnaam || persoonsData.voornaam) || '' }}
        {{ persoonsData.tussenvoegsel || '' }}
        {{ persoonsData.achternaam || '' }}
        <br />
        Indicatieve berekening {{ goalType }}
      </div>
      <div class="pagenumber" />
      <div class="break" />
    </div>

  </div>
</template>

<script>
export default {
  props: {
    offerType: {
      type: Number,
      required: true,
      default: 10,
    },
    rendement: Number,
    goalData: Object,
    persoonsData: Object,
    course: {
      required: true,
    },
    today: {
      type: Date,
      default: () => new Date(),
    },
  },
  computed: {
    offerTypeToText() {
      if (this.offerType === 0 || this.offerType === 5) {
        return 'Normale aanvang';
      }
      if (this.offerType === 1 || this.offerType === 4) {
        return 'Hoge aanvang';
      }
      if (this.offerType === 2) {
        return 'Vaste looptijd';
      }
      return 'Vaste uitkering'; // offerType === 3
    },
    goalType() {
      if (this.goalData.type === 'gouden-handdruk-opbouwend' || this.goalData.type === 'gouden-handdruk-uitkerend') {
        return 'Gouden handdruk';
      }
      if (this.goalData.type === 'netto-lijfrente-uitkerend') {
        return 'Netto lijfrente';
      }
      return 'Lijfrente';
    },
    renderVerloop() {
      if (this.offerType === 1 || this.offerType === 4) {
        return this.course.verloop;
      }
      if (this.offerType === 2) {
        return this.course.verloop3;
      }
      return this.course.verloop2;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../../scss/_paper.scss";
  h2 {
    margin-top: 30px;
    &:first-child {
      margin-top: 0;
    }
  }
  .transparent-table {
    tr {
      background-color: transparent;
    }
  }
</style>
